import {
  javascript,
  typescript,
  php,
  reactjs,
  nodejs,
  savisoft,
  entrata,
  devTa,
  postgres,
  sachin,
  raj,
  chris,
  deepikaKothari,
  shaliniSingh,
  inspectionIntelligence,
  fixoraAI,
  contentOS,
  dataLens,
  codeReviewBot,
  python,
  langgraph,
  langchain,
  docker,
  redis,
  kafka,
  rabbitmq,
  mongodb,
  aws,
  terraform,
  cicd,
  fastapi,
} from '../assets';

export const navLinks = [
  { id: 'about', title: 'About' },
  { id: 'projects', title: 'Case Studies' },
  { id: 'work', title: 'Experience' },
  { id: 'contact', title: 'Contact' },
];

const technologies = {
  'Languages & Frameworks': [
    { name: 'Python', icon: python },
    { name: 'JavaScript', icon: javascript },
    { name: 'TypeScript', icon: typescript },
    { name: 'PHP', icon: php },
    { name: 'React', icon: reactjs },
    { name: 'Node.js', icon: nodejs },
    { name: 'FastAPI', icon: fastapi },
  ],
  'Cloud & Infrastructure': [
    { name: 'AWS', icon: aws },
    { name: 'Docker', icon: docker },
    { name: 'Terraform', icon: terraform },
    { name: 'CI/CD', icon: cicd },
  ],
  'Data & Messaging': [
    { name: 'PostgreSQL', icon: postgres },
    { name: 'MongoDB', icon: mongodb },
    { name: 'Redis', icon: redis },
    { name: 'Kafka', icon: kafka },
    { name: 'RabbitMQ', icon: rabbitmq },
  ],
  'AI & Agent Systems': [
    { name: 'AWS Bedrock', icon: aws },
    { name: 'AWS AgentCore', icon: aws },
    { name: 'LangGraph', icon: langgraph },
    { name: 'LangChain', icon: langchain },
  ],
};

const experiences = [
  {
    title: 'Software Architect',
    company_name: 'Entrata India Private Limited',
    icon: entrata,
    iconBg: '#E6DEDD',
    date: 'January 2026 - Present',
    points: [
      'Lead architecture and engineering decisions for mission-critical operational platforms across leasing and financial workflows.',
      'Built and maintained APIs handling millions of requests per day, with async worker patterns that significantly reduced synchronous load.',
      'Designed data workflows and schema changes that improved query performance by 30-60% in high-traffic workflows.',
    ],
  },
  {
    title: 'Technical Lead',
    company_name: 'Entrata India Private Limited',
    icon: entrata,
    iconBg: '#383E56',
    date: 'January 2025 - December 2025',
    points: [
      'Re-architected financial and workflow systems, cutting end-to-end processing time by 83% (from 9 minutes to 70 seconds).',
      'Designed event-driven pipelines using RabbitMQ and Kafka to process millions of events daily and replace legacy trigger-based flows.',
      'Increased unit and integration coverage, contributing to a 60% reduction in post-release production issues.',
    ],
  },
  {
    title: 'Senior Software Engineer',
    company_name: 'Entrata India Private Limited',
    icon: entrata,
    iconBg: '#E6DEDD',
    date: 'July 2024 - December 2024',
    points: [
      'Drove engineering best practices across teams, improving code quality and deployment confidence by 60%.',
      'Designed and delivered scalable backend services for high-traffic resident workflows and core business operations.',
      'Led cross-functional collaboration on system design and architectural improvements.',
    ],
  },
  {
    title: 'Software Engineer III',
    company_name: 'Entrata India Private Limited',
    icon: entrata,
    iconBg: '#383E56',
    date: 'January 2023 - June 2024',
    points: [
      'Designed the Automated Assignment feature, reducing manual client effort by 99.6% (from 400+ clicks to a single click).',
      'Re-architected financial transaction workflows, reducing processing time by 83% (from 9 minutes to 1.3 minutes).',
      'Re-engineered the Move-In workflow, eliminating 561.4M+ redundant database transactions.',
    ],
  },
  {
    title: 'Software Engineer II',
    company_name: 'Entrata India Private Limited',
    icon: entrata,
    iconBg: '#E6DEDD',
    date: 'October 2021 - December 2022',
    points: [
      'Delivered backend and frontend features within a large legacy PHP platform serving millions of residents.',
      'Optimized database queries and indexing strategies, improving query performance by 40%.',
      'Increased test coverage, contributing to a 60% reduction in post-release issues.',
    ],
  },
  {
    title: 'Software Engineer',
    company_name: 'SaviSoft Private Limited',
    icon: savisoft,
    iconBg: '#383E56',
    date: 'March 2019 - October 2021',
    points: [
      'Grew from trainee to associate engineer, delivering full-stack web and CRM solutions for 100+ global clients.',
      'Engineered interactive frontend interfaces, contributing to a 40% increase in user retention.',
      'Enhanced backend performance by redesigning critical database schemas, improving data retrieval speeds by 60%.',
    ],
  },
];

const testimonials = [
  {
    testimonial:
      'Sachin is quality-driven, which is crucial in developing high-performance software. He stays up-to-date with the latest trends in the industry, making him well-rounded and adaptable. One of his outstanding qualities is his polite nature and kind personality, which make him a pleasure to work with.',
    name: 'Sachin Kumar Singh',
    designation: 'Co-Founder',
    company: 'SaviSoft',
    image: sachin,
  },
  {
    testimonial:
      'Sachin is a stellar developer! He never shied away from a difficult task and he would ask questions to better understand use cases so he could develop all intersections of function around his code. He has a keen eye for quality and is a natural problem solver. Sachin is a pleasure to work with.',
    name: 'Chris Bills',
    designation: 'Sr. Product Manager',
    company: 'Entrata, Inc.',
    image: chris,
  },
  {
    testimonial:
      "What sets Sachin apart is his ability to effectively collaborate with cross-functional teams and lead discussions. He is a kind, supportive colleague, and he is always eager to learn and improve. He is an exceptional Software Engineer who possesses a range of technical and personal qualities that make him a valuable asset to any team.",
    name: 'Rajkumar Mohite',
    designation: 'Sr. Engineering Manager',
    company: 'Entrata India',
    image: raj,
  },
  {
    testimonial:
      'Even as a Software Engineer, he consistently demonstrated the initiative and mindset of a leader. He was always the first to step up, whether it was tackling a tough new challenge or sharing knowledge that helped the entire team grow. His positive, can-do attitude was contagious and brought out the best in everyone around him.',
    name: 'Deepika Kothari',
    designation: 'Tech Lead',
    company: 'Entrata India',
    image: deepikaKothari,
  },
  {
    testimonial:
      'Sachin has the ability to quickly understand complex requirements and a problem-solving mindset which makes him a top-notch developer. He is a great communicator and team player who consistently delivers high-quality work. He truly cares about the success and well-being of his team members.',
    name: 'Shalini Singh',
    designation: 'Software Engineer',
    company: 'Entrata India',
    image: shaliniSingh,
  },
];

const projects = [
  {
    name: 'Inspection Intelligence',
    description:
      'Reduced manual inspection time by 95% using AI. Converts walkthrough videos into structured damage assessments with image comparison and automated reports.',
    problem: 'Property inspections required 45+ minutes of manual photo comparison and report writing per unit. At scale (thousands of units), this created a bottleneck that delayed move-in workflows and cost operations teams significant hours weekly.',
    constraints: 'Had to work with existing video capture workflows. Needed sub-5-minute processing per unit. Must handle variable video quality and lighting conditions. Zero tolerance for false negatives on damage detection.',
    architecture: 'FastAPI service that extracts frames from walkthrough videos, runs image comparison via AWS Rekognition and OpenCV for damage detection, and uses AWS Bedrock for structured report generation. React frontend for review and override.',
    tradeoffs: 'Chose frame extraction over real-time video analysis because it is simpler, cheaper, and good enough for the use case. Used Rekognition over custom models to avoid training data requirements and maintenance overhead. Accepted roughly 90% accuracy with a human review loop rather than chasing 99% at 10x the cost.',
    outcome: '95% reduction in manual inspection time. Processing under 3 minutes per unit. Adopted across multiple property management workflows.',
    visibility: 'private',
    implementation_note:
      'Built for enterprise production systems. I can walk through the architecture, tradeoffs, and outcomes in a technical discussion.',
    tags: [
      { name: 'React' },
      { name: 'FastAPI' },
      { name: 'AWS Bedrock' },
      { name: 'Rekognition' },
      { name: 'OpenCV' },
    ],
    image: inspectionIntelligence,
    source_code_link: null,
  },
  {
    name: 'FixoraAI',
    description:
      'Two-lane maintenance assistant built on LangGraph. It routes requests through workflow and inquiry lanes with practical guardrails and escalation paths.',
    problem: 'Maintenance requests in property management are a mix of actionable work orders and informational inquiries. Existing systems treated them identically, causing misrouted tickets, delayed responses, and wasted technician time.',
    constraints: 'Must classify and route in under 2 seconds. Cannot hallucinate work orders because wrong routing has real cost. Needs to handle ambiguous requests gracefully with escalation rather than guessing.',
    architecture: 'LangGraph-based orchestration with two lanes: a workflow lane (creates and updates work orders) and an inquiry lane (answers questions from knowledge base). Shared state graph with guardrails at each node. PostgreSQL for conversation history and audit trail.',
    tradeoffs: 'Chose LangGraph over a simple prompt chain because routing logic needed conditional branching and state management. Used Streamlit for rapid prototyping over a full React frontend since speed to validation mattered more than polish. Accepted higher latency from multi-step graph execution over a single LLM call for better accuracy.',
    outcome: 'Correctly routes 94% of requests without human intervention. Escalation path catches edge cases. Reduced average response time for maintenance inquiries.',
    visibility: 'private',
    implementation_note:
      'Source is private. I can walk through the orchestration design, runtime decisions, and production constraints.',
    tags: [
      { name: 'LangGraph' },
      { name: 'Streamlit' },
      { name: 'PostgreSQL' },
      { name: 'AWS Bedrock' },
    ],
    image: fixoraAI,
    source_code_link: null,
  },
  {
    name: 'ContentOS',
    description:
      'Local-first AI content platform that orchestrates offline LLMs and image models for multimodal content generation with privacy-first processing.',
    problem: 'Content teams needed AI-assisted generation but could not send proprietary data to cloud APIs due to privacy policies. Existing tools were either cloud-only or required significant GPU infrastructure.',
    constraints: 'Must run entirely on local hardware with no cloud API calls. Needs to support both text and image generation. Must work on consumer-grade GPUs (8-16GB VRAM). Content quality must be reviewable before publishing.',
    architecture: 'FastAPI backend orchestrating Ollama for text generation and Stable Diffusion for images. React frontend with a content pipeline UI covering draft, review, edit, and publish stages. Local-first storage with optional export.',
    tradeoffs: 'Chose Ollama over direct model hosting for simpler model management and updates. Accepted lower quality from smaller local models compared to GPT-4 or Claude in exchange for complete data privacy. Built a review step into the pipeline rather than optimizing for fully automated output.',
    outcome: 'Fully functional local AI content platform. Zero data leaves the machine. Supports text + image generation on a single consumer GPU.',
    tags: [
      { name: 'FastAPI' },
      { name: 'React' },
      { name: 'Ollama' },
      { name: 'Stable Diffusion' },
    ],
    image: contentOS,
    visibility: 'public',
    source_code_link: 'https://github.com/ersachinsaurav/ContentOS',
  },
  {
    name: 'DataLens',
    description:
      'SQL assistant that turns natural-language questions into database insights with automated charts and schema-aware query generation for operational teams.',
    problem: 'Operations teams needed database insights but could not write SQL. Existing BI tools required training and did not handle ad-hoc questions well. Data team was bottlenecked with report requests.',
    constraints: 'Must be schema-aware to avoid invalid queries. Cannot execute destructive operations. Needs to handle ambiguous questions by asking for clarification rather than guessing. Must visualize results automatically.',
    architecture: 'LangGraph agent with schema introspection that generates SQL from natural language. FastAPI backend with query validation and execution sandboxing. Next.js frontend with auto-generated charts based on result shape. Terraform-managed infrastructure.',
    tradeoffs: 'Chose LangGraph over a simple text-to-SQL prompt because multi-step reasoning (schema lookup, query generation, validation, execution) needed explicit state management. Used read-only database replicas to eliminate destructive query risk entirely rather than relying on LLM guardrails alone.',
    outcome: 'Operations teams self-serve 80% of their data questions. Data team request backlog reduced significantly. Auto-visualization eliminates manual chart creation.',
    visibility: 'private',
    implementation_note:
      'Includes private implementation details and production configurations. I can share a high-level technical walkthrough.',
    tags: [
      { name: 'LangGraph' },
      { name: 'FastAPI' },
      { name: 'Next.js' },
      { name: 'Terraform' },
    ],
    image: dataLens,
    source_code_link: null,
  },
  {
    name: 'CodeReview Bot',
    description:
      'Automated code review assistant using Claude via AWS Bedrock. Supports 15+ languages with syntax highlighting and rate limits.',
    problem: 'Code reviews were a bottleneck. Senior engineers spent hours reviewing routine PRs, delaying feature delivery. Most review comments were about patterns, not logic.',
    constraints: 'Must support 15+ languages. Needs rate limiting to control API costs. Must provide actionable feedback, not generic suggestions. Cannot replace human review for architectural decisions.',
    architecture: 'React frontend with syntax highlighting and diff view. Express backend that chunks code, sends to Claude via AWS Bedrock with language-specific prompts, and aggregates feedback. Rate limiting per user and per repository.',
    tradeoffs: 'Chose Claude over GPT-4 for better code understanding at the time of building. Implemented chunking over full-file analysis to handle large files within context limits. Added rate limiting at the application layer rather than relying on AWS throttling for a better user experience.',
    outcome: 'Catches roughly 70% of routine review comments automatically. Senior engineers focus on architecture and logic reviews. Review cycle time reduced.',
    tags: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'AWS Bedrock' },
      { name: 'Claude' },
    ],
    image: codeReviewBot,
    visibility: 'public',
    source_code_link: 'https://github.com/ersachinsaurav/CodeReviewBot',
  },
  {
    name: 'DevAssist',
    description:
      'Developer productivity tool for code, docs, and test generation. Shortened review cycles by 50% in internal usage.',
    problem: 'Developers spent significant time on boilerplate, writing tests, documentation, and repetitive code patterns. This slowed down delivery without adding engineering value.',
    constraints: 'Must integrate with existing workflows. Generated code must be editable, not a black box. Must handle multiple output types (code, docs, tests) from a single interface.',
    architecture: 'React frontend with a unified prompt interface. Node.js backend that routes to OpenAI with context-aware prompts based on output type. Template system for consistent formatting across generated artifacts.',
    tradeoffs: 'Chose a single unified interface over separate tools for each output type for simpler UX and easier adoption. Used OpenAI directly rather than building a custom model since the task is well-suited to general-purpose LLMs. Accepted that generated tests need human validation rather than auto-running them.',
    outcome: '50% reduction in review cycle time for routine PRs. Adopted by internal team for documentation and test scaffolding.',
    tags: [
      { name: 'React' },
      { name: 'Node.js' },
      { name: 'OpenAI' },
    ],
    image: devTa,
    visibility: 'public',
    source_code_link: 'https://github.com/ersachinsaurav/Projects/tree/main/MERN/entrata-dev-assist',
  },
];

export { technologies, experiences, testimonials, projects };
